window.$ = window.jQuery = require('jquery');

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: true});
    }
};

window.select2 = require('select2');

$(document).ready(function () {
    $('#back_button_check').val(1);

    if (isMobileBrowser()) {
        // Avoid add a .mobile class to the body element if on mobile
        $('body').addClass('is-mobile').removeClass('is-not-mobile');
    }
});

$(window).on('load', function () {
    $('.page-loader').removeClass('jquery-loaded');
    setTimeout(function(){
        $('.page-loader').animate({
            opacity: 0
        }, 500, function () {
            $(this).hide();
        });
    }, 50);
});